// Check TS is after 1262304000: Friday, January 1, 2010 12:00:00 AM
export const checkTsAfter2010 = (ts: number) => {
	return Math.floor(new Date(ts).getTime()) > 1262304000000;
};

// Check Date is after 1262304000: Friday, January 1, 2010 12:00:00 AM
export const checkDateAfter2010 = (ts: Date) => {
	return Math.floor(ts.getTime()) > 1262304000000;
};

// Filters out all timestamps before 2010 in all arrays on an object. Used for graph data
export const filterTsAfter2010 = (obj: any | undefined | null) => {
	if (obj === undefined || obj === null) return;
	Object.keys(obj).forEach(key => {
		if (Array.isArray(obj[key])) {
			obj[key] = filterArrayByTsAfter2010(obj[key]);
		}
	});
};

// Filters out all timestamps before 2010 in an array
export const filterArrayByTsAfter2010 = (arr: any[] | null) => {
	return arr?.filter((dataPoint: { timestamp: number }) => {
		if (dataPoint && dataPoint.timestamp) {
			return checkTsAfter2010(dataPoint.timestamp);
		}
		return false;
	});
};
